import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { WmsPickingCartContainer } from "../../../../../models/aggregates/warehouse/index";
import { ApiResponseModel } from '../shared/api-response.model';
import { Observable } from 'rxjs';
import { ApiVisa } from '../shared';

@Injectable({ providedIn: "root" })
export class WmsPickingCartService extends BaseApiTemplateService<WmsPickingCartContainer> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-carts/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-carts/backoffice-ep";
    this.httpClient = http;
  }

  public getBySnapshotCriteria(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-carts/snapshot/backoffice-ep/query";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      payload,
      this.getHttpHeader(visa)
    );
  }

  public getCount(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  "warehouses/picking-carts/snapshot-total-records/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      payload,
      this.getHttpHeader(visa)
    );
  }

  public createMulti(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-carts/multi/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      payload,
      this.getHttpHeader(visa)
    );
  }
  
  public updateMulti(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-carts/multi/backoffice-ep";
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      url,
      payload,
      this.getHttpHeader(visa)
    );
  }

  public deleteMulti(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-carts/multi-delete/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public createCartFromContainerScan(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-carts/create-cart-from-container-scans/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
